import { AsyncPipe, CurrencyPipe } from '@angular/common';
import { Component, DestroyRef, inject } from '@angular/core';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { TranslocoPipe } from '@jsverse/transloco';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { LombardFacade } from '@zero/lombard/domain';
import { ButtonComponent, ModalComponent } from '@zero/shared/ui-web-design-system';
import { filter } from 'rxjs';

@Component({
  templateUrl: './lombard-edit-modal.component.html',
  styleUrls: ['./lombard-edit-modal.component.scss'],
  imports: [TranslocoPipe, CurrencyPipe, AsyncPipe, ButtonComponent, ModalComponent],
})
export class LombardEditModalComponent {
  public readonly modal = inject(NgbActiveModal);
  public readonly facade = inject(LombardFacade);
  readonly #destroyRef = inject(DestroyRef);

  public currentCredit = 0;

  public handleDropdownChange = (_: Event, creditLine: string): void => {
    this.currentCredit = Number(creditLine);
  };

  public applyForCredit = (suggestedCredit: number): void => {
    const credit = this.currentCredit || suggestedCredit;
    credit && this.facade.applyForCredit(credit);
    this.facade.hasAppliedCredit$
      .pipe(
        filter((hasApplied) => !!hasApplied),
        takeUntilDestroyed(this.#destroyRef),
      )
      .subscribe(() => this.modal.close());
  };
}
